import { useCallback, useRef } from "react"

export const useDebouncedCallback = <T extends unknown[]>(
  callback: (...args: T) => void,
  delay = 600,
) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  return useCallback(
    (...args: T) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        callback(...args)
      }, delay)
    },
    [callback, delay],
  )
}
